import axios from 'axios';

// const API_BASE_URL = 'https://api.mmwmachine.com';
const API_BASE_URL = 'https://api.mmwmachine.com';

const api = axios.create({
  baseURL: API_BASE_URL,
});

// --- Category APIs ---
export const fetchCategories = () => api.get('/categories');
export const createCategory = (categoryData) => api.post('/categories', categoryData);
export const updateCategoryById = (id, updatedData) => api.patch(`/categories/${id}`, updatedData);
export const deleteCategoryById = (id) => api.delete(`/categories/${id}`);

// --- Product APIs ---
export const fetchProducts = () => api.get('/products');
export const createProduct = (productData) => api.post('/products', productData);
export const updateProduct = (id, updatedData) => api.put(`/products/${id}`, updatedData);
export const deleteProductById = (id) => api.delete(`/products/${id}`);
export const updateProductById = (id, data) => api.patch(`/products/${id}`, data);

export const fetchAccessories = () => axios.get('/accprice');
export const createAccessory = (data) => axios.post('/accprice', data);
export const deleteAccessoryById = (id) => axios.delete(`/accprice/${id}`);
export const updateAccessoryById = (id, data) => axios.patch(`/accprice/${id}`, data);


export default api;
